const points = [
  {
    icon: "ri-briefcase-line",
    title: "Business-focused",
    desc: "Technology designed around real business objectives.",
  },
  {
    icon: "ri-stack-line",
    title: "Built to scale",
    desc: "Solutions designed to grow with your organization.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Human-centered",
    desc: "Simple experiences for the people who actually use them.",
  },
];

export default function TrustStrip() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px]">
        <div className="max-w-3xl">
          <h2 className="font-heading text-2xl md:text-3xl font-bold leading-tight tracking-tight text-foreground-950">
            Technology should solve problems, not create more of them.
          </h2>
          <p className="mt-4 text-lg text-foreground-600 leading-relaxed">
            We combine strategy, design and technology to create practical
            digital experiences built around how your organization actually
            works.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {points.map((p) => (
            <div
              key={p.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}